import React from 'react'
import cx from 'helpers/cx'
import PropTypes from 'prop-types'

import classes from './PageLayout.module.scss'

const PageLayout = ({
  title,
  subtitle,
  banner,
  breadcrumb,
  children,
  footer,
  actions,
  compactActions,
  compactHero,
  suppressPrintChrome,
}) => (
  <div className={cx(classes.page, 'layout-page', suppressPrintChrome && classes.printMinimal)}>
    <div className={cx(classes.heroInner, compactHero && classes.heroInnerCompact, 'layout-container')}>
      {(title || subtitle || banner) && (
        <header className={cx(classes.hero, compactHero && classes.heroCompact)}>
          {title && <div className={classes.title}>{title}</div>}
          {subtitle && <div className={classes.subtitle}>{subtitle}</div>}
          {banner && <div className={classes.banner}>{banner}</div>}
        </header>
      )}
    </div>
    <div className="layout-content">
      <div className={cx(classes.contentInner, 'layout-container')}>
        {breadcrumb && <div className={classes.toolbar}>{breadcrumb}</div>}
        <div className="layout-section-stack">{children}</div>
        {footer && <div className={classes.footer}>{footer}</div>}
        {actions && (
          <div className={cx(classes.actions, compactActions && classes.actionsCompact)}>
            {actions}
          </div>
        )}
      </div>
    </div>
  </div>
)

PageLayout.displayName = 'PageLayout'
PageLayout.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  banner: PropTypes.node,
  breadcrumb: PropTypes.node,
  children: PropTypes.node,
  footer: PropTypes.node,
  actions: PropTypes.node,
  compactActions: PropTypes.bool,
  compactHero: PropTypes.bool,
  suppressPrintChrome: PropTypes.bool,
}

export default PageLayout
